export default {"src":"/_next/static/media/placeholder-8.610cd8e9.svg","height":190,"width":352};